export default __webpack_public_path__ + "static/media/logo-dark.c4ff9340.png";